<template>
	<div class="main">
		<hwk-header></hwk-header>
		<div class="warp notice-warp">
			<div class="navback pointer" @click="goBack">
				<i class="el-icon-arrow-left"></i>公告详情
			</div>
			<div class="notice-title">{{data.title}}</div>
			<div class="notice-time">发布时间:{{$timeFormat(data.createtime,'yyyy-mm-dd hh:MM:ss')}}</div>
			<div class="notice-body">
				<div class="title">{{data.title}}</div>
				<div class="body" v-html="data.content">

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	export default {
		components: {
			hwkHeader
		},
		data() {
			return {
				data: {}
			};
		},
		created() {
			// this.getlist();
			if (localStorage.getItem('noticeInfo')) {
				this.data = JSON.parse(localStorage.getItem('noticeInfo'))
			} else {
				this.$router.go(-1);
			}

		},
		methods: {

			goBack() {
				this.$router.go(-1);
			}
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;

	.notice-warp {
		padding: 20px 0;
		text-align: left;

		.notice-title {
			margin-top: 20px;
			font-size: 20px;
			line-height: 30px;
			color: @color1;
		}

		.notice-time {
			margin-top: 10px;
			font-size: 14px;
			line-height: 24px;
			color: #A9A9A9;
		}

		.notice-body {
			margin-top: 20px;
			padding: 20px;
			border-top: 1px solid #eee;

			.title {
				font-size: 36px;
				text-align: center;
				font-weight: 600;
				line-height: 30px;
				color: @color1;
			}

			.body {
				margin-top: 20px;
			}
		}

		.navback {
			text-align: left;
			font-size: 14px;
			color: #666;
			line-height: 30px;


			i {
				margin-right: 5px;
			}
		}
	}
</style>